export enum StudentTab {
  Dashboard = 'Dashboard',
  Calendar = 'Calendar',
  Assignments = 'Assignments',
  Content = 'Content',
  StudyGuides = 'StudyGuides',
  Flashcards = 'Flashcards',
  Refund = 'Refund',
  Syllabus = 'Syllabus',
}

export enum InstructorTab {
  Dashboard = 'Dashboard',
  Calendar = 'Calendar',
  Assignments = 'Assignments',
  Students = 'Students',
  Content = 'Content',
  Questions = 'Questions',
  Slides = 'Slides',
  Flashcards = 'Flashcards',
  Modules = 'Modules',
  Settings = 'Settings',
  ContentHub = 'ContentHub',
  Prompts = 'Prompts',
  LearningObjectives = 'LearningObjectives',
}
